module.exports = __webpack_public_path__ + "img/warningCentre.e61db4ee.svg";